import { createIcon, IconColors } from './icon-utils';

export const ReSyncIcon = createIcon({
  fill: IconColors.DarkGrey,
  path: 'M3 15C2.5875 15 2.23438 14.8531 1.94063 14.5594C1.64688 14.2656 1.5 13.9125 1.5 13.5V4.5C1.5 4.0875 1.64688 3.73438 1.94063 3.44063C2.23438 3.14688 2.5875 3 3 3H6.75V4.5H3V13.5H15V4.5H11.25V3H15C15.4125 3 15.7656 3.14688 16.0594 3.44063C16.3531 3.73438 16.5 4.0875 16.5 4.5V13.5C16.5 13.9125 16.3531 14.2656 16.0594 14.5594C15.7656 14.8531 15.4125 15 15 15H3ZM9 11.55L5.25 7.8L6.3 6.75L8.25 8.7V3H9.75V8.7L11.7 6.75L12.75 7.8L9 11.55Z',
  style: {
    height: 18,
    width: 18,
  },
  viewBox: '0 0 18 18',
});
